module.exports = __webpack_public_path__ + "img/welcome-dashboard-1.f3f747c6.png";